<template>
    <a-modal
            title="选择供应商"
            :visible="visible"
            @ok="handleOk"
            @cancel="handleCancel"
            :width="1000"
    >
        <div>
        <span>
          供应商信用代码：
            <a-input @keyup.13.native="onSearch" placeholder="请输入统一社会信用代码" v-model="queryParam.supplierCode"
                     style="width:200px"></a-input>
        </span>
            <span>
          供应商名称：
          <a-input @keyup.13.native="onSearch" placeholder="请输入供应商名称" v-model="queryParam.supplierName"
                   style="width:200px"></a-input>
        </span>
            <a-button type="primary" class="ml-5" icon="search" @click="onSearch">查询</a-button>
            <a-button type="Default" class="ml-5" @click="clearMethod">重置</a-button>

        </div>
        <div class="mt-4">
            已选供应商：
            <a-button-group size="small" class="ml-2 mt-2" v-for="(item) in userSelectContent">
                <a-button >{{item.supplierName}}</a-button>
                <a-button @click="removeMethod(item)" type="danger">
                   <a-icon type="delete"></a-icon>
                </a-button>
            </a-button-group>
        </div>
        <s-table
                class="mt-4"
                ref="table"
                :rowSelection="{selectedRowKeys: selectedSupRowKeys, onChange: onSelectChange,type:selectionType}"
                :columns="columns"
                :pagination="taskPagination"
                :pageSize="pageSize"
                :data="loadData"
                :rowKey="record => record.id"
        >
        </s-table>
    </a-modal>

</template>

<script>
    import {PageView} from '@/layouts'
    import STable from '@/components/Table'
    import qs from 'qs'

    export default {
        name: 'AddLHTSupplier',
        components: {
            PageView,
            STable
        },
        mounted() {
        },
        props: {
            visible: {},
            selectionType: {
                type: String,
                default: "checkbox"
            },
            supplierId: {
                type: String,
                default: ""
            },
            pageSize: {
                type: Number,
                default: 5
            },
            pageSizeOptions: {
                type: Array,
                default() {
                    return ['5', '8']
                }
            }
        },
        data() {
            return {
                bzid: '',
                xmid: '',
                taskNum: null,
                taskPages: null,
                taskPagination: {
                    showTotal: total => `共 ${this.taskNum} 条`,
                    size: 'small',
                    pageSizeOptions: this.pageSizeOptions
                },
                userSelectContent: [],//用户勾选的内容
                selectedSupRowKeys: [],
                columns: [
                    {
                        title: '供应商名称',
                        dataIndex: 'supplierName'
                    },
                    {
                        title: '统一社会信用代码',
                        dataIndex: 'supplierCode'
                    },
                    {
                        title: '地址',
                        dataIndex: 'supplierAddress'
                    },
                ],
                queryParam: {
                    supplierCode: '',
                    supplierName: '',
                },
                queryFrom: {
                    supplierCode: '',
                    supplierName: '',
                },
                copyData: [],
                loadData: parameter => {
                    return this.$http.get('/api/v1/supplier/legalsign/getBidSupplierList2.json', {
                        params: Object.assign(parameter, this.queryParam,{bzId:this.bzid}),
                        paramsSerializer: function (params) {
                            return qs.stringify(params, {indices: false})
                        }
                    }).then(res => {
                        if (res.page) {
                            this.taskPages = res.page.pages
                            this.taskNum = res.page.total
                        }
                        if (res.code == 200) {
                            this.copyData = []
                            this.copyData = res.result
                        }
                        return res
                    })
                }
            }
        },
        methods: {
            preView(bzid,xmid,bzSupData) {
                let that = this
                that.bzid = bzid
                that.xmid = xmid
                that.selectedSupRowKeys = []
                bzSupData.forEach(item=>{
                    that.selectedSupRowKeys.push(item.supplierId)
                    item.id = item.supplierId
                })
                that.userSelectContent=[...bzSupData]
            },
            handleOk() {
                let that = this
                const supData = []
                let error = false
                that.userSelectContent.forEach(item => {
                    const selectData = {}
                    if (item.id === that.supplierId) {
                        error = true
                    }
                    selectData.supplierName = item.supplierName
                    selectData.supplierCode = item.supplierCode
                    selectData.supplierId = item.id
                    selectData.bzid = that.bzid
                    selectData.xmid = that.xmid
                    supData.push(selectData)
                })
                if (error) {
                    that.$message.error("不能选择主体供应商！！！")
                    return
                }
                this.$emit('success', supData,that.bzid)
            },
            handleCancel() {
                this.$emit('cancel')
            },
            //清空的方法
            clearMethod() {
                this.queryParam = {}
                this.$refs.table.refresh()
            },
            onSelectChange(selectedRowKeys, selectedRows) {
                this.selectedSupRowKeys = selectedRowKeys
                for (let i = 0; i < selectedRowKeys.length; i++) {
                    let isExists = false
                    for (let j = 0; j < this.userSelectContent.length; j++) {
                        if (selectedRowKeys[i] == this.userSelectContent[j].id) {
                            isExists = true
                            break
                        }
                    }
                    if (!isExists) {//如果不存在
                        for (let j = 0; j < this.copyData.length; j++) {
                            if (selectedRowKeys[i] == this.copyData[j].id) {
                                this.userSelectContent.push(this.copyData[j])
                                break
                            }
                        }
                    }
                }
                for (let i = 0; i < this.userSelectContent.length; i++) {
                    let isDelete = true
                    for (let j = 0; j < selectedRowKeys.length; j++) {
                        if (this.userSelectContent[i].id == selectedRowKeys[j]) {
                            isDelete = false
                            break
                        }
                    }
                    if (isDelete) {
                        this.userSelectContent.splice(i, 1)
                        i--
                    }
                }
            },
            onSearch() {
                this.$refs.table.refresh(true)
            },
            removeMethod(data) {
                this.userSelectContent = this.userSelectContent.filter(item=>item.id!==data.id)
                this.selectedSupRowKeys =  this.selectedSupRowKeys.filter(item=>item!== data.id)

                // let removeEle = this.userSelectContent[index]
                // for (let i = 0; i < this.selectedSupRowKeys.length; i++) {
                //     if (this.selectedSupRowKeys[i] == removeEle.id) {
                //         this.selectedSupRowKeys.splice(i, 1)
                //         break
                //     }
                // }
                // this.userSelectContent.splice(index, 1)
            }
        }
    }
</script>

<style lang="less" scoped>
    .card {
        margin-bottom: 24px;
    }

    /*.close-span:hover {*/
    /*    cursor: pointer;*/
    /*}*/
</style>
